Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketCreatePatagoniaCrmCaseActionView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/action/ticket_create_patagonia_crm_case_action']

  events:
    'click button': '_onClick'

  actionSelector:
    '.ticket-action'

  initialize: =>
    @listenTo(@model, 'ticket:export:patagonia:success', @_onSuccess)
    @listenTo(@model, 'ticket:export:patagonia:error', @_onError)
    @onSuccessMessage = I18n.t('customer.dashboard.conversations.details.integrations.patagonia_crm_case_created')
    @onErrorMessage = I18n.t('customer.dashboard.conversations.details.integrations.patagonia_crm_case_error')

  execute: =>
    @model.export()

  canExecute: =>
    @model.canCreateExternalTicket()

  canRender: =>
    @model.canUpdate() &&
      @canExecute()

  render: =>
    @$el.html(@template(
      model: @model
      text: @_text()
    ))
    @

  enable: =>
    @_actionButton().removeClass('disabled')
    @_actionButton().attr('disabled', false)

  disable: =>
    @_actionButton().addClass('disabled')
    @_actionButton().attr('disabled', true)

  _actionButton: =>
    @$el.find(@actionSelector)

  _onClick: =>
    @_onStart()
    @onClickCreateCrmCase('patagonia')

  _onStart: =>
    @disable()
    showInformation(@onStartMessage) if @onStartMessage

  _onSuccess: (message) =>
    message ||= @onSuccessMessage
    @_updateText()
    showSuccess(message) if message

  _onError: (message) =>
    message ||= @onErrorMessage
    @enable()
    showError(message) if message

  _updateText: =>
    @render()

  _text: =>
    if @model.isLinkedToCrm()
      I18n.t('customer.dashboard.conversations.details.integrations.patagonia_crm_case_linked')
    else
      I18n.t('customer.dashboard.conversations.details.integrations.patagonia_crm_create_case')

  unbindEvents: =>
    @stopListening()
    @model.stopListening()
